import CalenderIcon from '@/assets/images/ConfirmSessionIcon.svg';
import FitCurveIcon from '@/assets/images/FitCurveIcon.svg';
import FitPrimeIcon from '@/assets/images/FitPrimeIcon.svg';
import FitVarsityIcon from '@/assets/images/FitVarsityIcon.svg';
import TriangleArrow from '@/assets/images/traingleArrow.svg';
import { AvailabilityTimezone } from '@/components/common/TimezoneSelect/timezoneSelect';
import { Button } from '@/components/ui/button';
import { DatePicker } from '@/components/ui/date-picker';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { CustomInput } from '@/components/ui/input';
import { Modal } from '@/components/ui/modal';
import { SelectComponent } from '@/components/ui/select';
import { Skeleton } from '@/components/ui/skeleton';
import { showToast } from '@/components/ui/sonner';
import { TimePicker } from '@/components/ui/time-select';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { GET_ALL_PROGRAM, GET_ALL_SPORTS, GET_ALL_TRAINING_TYPE } from '@/Graphql/queries';
import timezones from '@/lib/timezones.json';
import { handleError } from '@/lib/utils';
import { getRoutes } from '@/routes/routePaths';
import { Session } from '@/Types/gql/graphql';
import { authState } from '@/vars/auth';
import { useMutation, useQuery, useReactiveVar } from '@apollo/client';
import { zodResolver } from '@hookform/resolvers/zod';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { Calendar } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { z } from 'zod';
import { CREATE_SESSION, UPDATE_SESSION } from '../GraphQl/mutation';

dayjs.extend(utc);
dayjs.extend(timezone);
interface ScheduleSessionSchema {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  sessionData?: Session;
  sessionUpdation?: () => void;
  selectedProgram?: string;
  sessionBalance?: number;
  freeSessionBalance?: number;
  fitPrimeBalance?: number;
  fitCurveBalance?: number;
  fitVarsityBalance?: number;
  ageRange?: string;
}

// const timezonesList = timezones.map((tz) => ({
//   label: `(UTC${tz.offset >= 0 ? '+' : ''}${convertOffset(tz.offset)}) ${tz.text.split(') ')[1]} (${tz.abbr})`,
//   value: tz.utc,
// }));
const timezonesList = timezones.map((tz) => ({
  // label: `(UTC${tz.offset >= 0 ? '+' : ''}${convertOffset(tz.offset)}) ${tz.value} (${tz.abbr})`,
  label: `${tz.text.split(') ')[0] + ')'} ${tz.value} (${tz.abbr})`,
  value: tz.utc,
}));

const getNextNearest30Min = (dateTime: Date) => {
  const current = dayjs(dateTime);
  const minutes = current.minute();
  const next30Min = minutes < 30 ? 30 : 60;
  return current.minute(next30Min).second(0).millisecond(0).toDate();
};

export const scheduleSessionSchema = z.object({
  trainingType: z.string().optional(), // Made optional since it's only required for FitPrime
  dateTime: z.date().refine(
    (date) => {
      const now = new Date();
      return date > now;
    },
    { message: 'Session time must be in the future' },
  ),
  timezone: z.string().min(1, 'Timezone is required'),
  quickSelect: z.string().min(1, 'Date selection is required'),
  sport: z.string().optional(), // Made optional since it's only required for FitVarsity
  position: z.string().optional(), // Made optional since it's only required for FitVarsity
});

type ScheduleSessionSchemaType = z.infer<typeof scheduleSessionSchema>;

const ScheduleSession: React.FC<ScheduleSessionSchema> = ({
  open,
  setOpen,
  sessionData,
  sessionUpdation,
  selectedProgram,
  freeSessionBalance,
  fitPrimeBalance,
  fitCurveBalance,
  fitVarsityBalance,
  ageRange,

}) => {
  const { userDetails } = useReactiveVar(authState);
  const { data: trainingTypes, loading: trainingTypesLoading } = useQuery(GET_ALL_TRAINING_TYPE, {
    variables: { sort: { order: 1 }, limit: 30, offset: 0 },
  });

  console.log(fitPrimeBalance, fitCurveBalance, fitVarsityBalance);


  const { data: programsData, loading: programsLoading } = useQuery(GET_ALL_PROGRAM, {
    variables: {
      // filter: { status: 'Active' },
      // sort: { createdAt: 1 },
      limit: 10,
      offset: 0,
    },
  });

  const { data: sportsData, loading: sportsLoading } = useQuery(GET_ALL_SPORTS, {
    variables: {
      limit: 20,
      offset: 0,
      sort: { 'sportName': 1 },
    },
  });
  const {
    watch,
    setValue,
    getValues,
    resetField,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<ScheduleSessionSchemaType>({
    resolver: zodResolver(scheduleSessionSchema),
    defaultValues: {
      dateTime: undefined,
      quickSelect: 'today',
      trainingType: '',
      sport: '',
      position: '',
    },
  });
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [currentProgram, setCurrentProgram] = useState<string>(selectedProgram || '');
  const [currentProgramId, setCurrentProgramId] = useState<string>('');
  // const [selectedSportId, setSelectedSportId] = useState<string>('');
  const [quickSelect, setQuickSelect] = useState<string>('today');
  const [datePickerKey, setDatePickerKey] = useState<number>(0);
  // const [selectedSport, setSelectedSport] = useState<string>('');
  // const [selectedPosition, setSelectedPosition] = useState<string>('');

  // Sports options from API
  const sportsOptions =
    sportsData?.getAllSports?.map((sport) => ({
      value: sport?._id || '',
      text: sport?.sportName || '',
    })) || [];

  // Helper function to handle program change
  const handleProgramChange = (programName: string, programId: string) => {
    // Check balance if freeSessionBalance is 0
    if (freeSessionBalance === 0) {
      let balance = 0;
      let errorMessage = '';

      switch (programName.toLowerCase()) {
        case 'fitprime':
          balance = fitPrimeBalance ?? 0;
          errorMessage = 'You don\'t have enough FitPrime sessions left. Please buy more to continue.';
          break;
        case 'fitcurve':
          balance = fitCurveBalance ?? 0;
          errorMessage = 'You don\'t have enough FitCurve sessions left. Please buy more to continue.';
          break;
        case 'fitvarsity':
          balance = fitVarsityBalance ?? 0;
          errorMessage = 'You don\'t have enough FitVarsity sessions left. Please buy more to continue.';
          break;
      }

      if (balance === 0) {
        showToast({
          message: errorMessage,
          variant: 'error'
        });
        return; // Don't proceed with program change
      }
    }

    setCurrentProgram(programName);
    setCurrentProgramId(programId);
    // Clear training type error when switching away from FitPrime
    if (programName !== 'fitprime' && errors.trainingType) {
      setValue('trainingType', '', { shouldValidate: true });
    }
    // Clear sport and position errors when switching away from FitVarsity
    if (programName !== 'fitvarsity') {
      if (errors.sport) {
        setValue('sport', '', { shouldValidate: true });
      }
      if (errors.position) {
        setValue('position', '', { shouldValidate: true });
      }
    }
  };

  // Helper functions for date management
  const convertToToday = (dateTime: Date) => {
    const original = dayjs(dateTime);
    return dayjs()
      .startOf('day')
      .hour(original.hour())
      .minute(original.minute())
      .second(original.second())
      .toDate();
  };

  const convertToTomorrow = (dateTime: Date) => {
    const original = dayjs(dateTime);
    return dayjs()
      .add(1, 'day')
      .startOf('day')
      .hour(original.hour())
      .minute(original.minute())
      .second(original.second())
      .toDate();
  };

  const handleQuickSelect = (value: string) => {
    setQuickSelect(value);
    setValue('quickSelect', value);

    if (value === 'today') {
      setValue('dateTime', convertToToday(getValues('dateTime')), {
        shouldValidate: true,
      });
    } else if (value === 'tomorrow') {
      setValue('dateTime', convertToTomorrow(getValues('dateTime')), {
        shouldValidate: true,
      });
    } else if (value === 'custom') {

      resetField('dateTime');
      // Force DatePicker to re-render and clear its internal state
      setDatePickerKey((prev) => prev + 1);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [createSession, { loading }] = useMutation(CREATE_SESSION, {
    refetchQueries: ['GetAllSession', 'GetSessionBalance'],
    onCompleted: () => {
      handleClose();
      sessionUpdation?.();
      showToast({ message: 'Session created successfully', variant: 'success' });
      setShowConfirmModal(false);
    },
    onError: handleError,
  });
  const [updateSession, { loading: updateLoading }] = useMutation(UPDATE_SESSION, {
    refetchQueries: ['GetAllSession', 'GetSessionById', 'GetAllSessionsCount'],
    onCompleted: () => {
      handleClose();
      sessionUpdation?.();
      showToast({ message: 'Session updated successfully', variant: 'success' });
      setShowConfirmModal(false);
    },
    onError: handleError,
  });

  useEffect(() => {
    if (sessionData) {
      const convertedTime = dayjs.utc(sessionData.sessionStartTime).tz(sessionData.timeZone);
      setValue('dateTime', (convertedTime as any).$d);
      const today = dayjs().startOf('day');
      const tomorrow = today.add(1, 'day');
      const selectedDate = dayjs(sessionData.sessionStartTime).startOf('day');

      if (selectedDate.isSame(today)) {
        setValue('quickSelect', 'today');
        setQuickSelect('today');
      } else if (selectedDate.isSame(tomorrow)) {
        setValue('quickSelect', 'tomorrow');
        setQuickSelect('tomorrow');
      } else {
        setValue('quickSelect', 'custom');
        setQuickSelect('custom');
      }
      setValue('timezone', sessionData.timeZone);
      setValue('trainingType', sessionData?.trainingType?._id || '');

      // Set sport and position for FitVarsity program
      if (sessionData.sportId) {
        setValue('sport', sessionData.sportId);
      }
      if (sessionData.position) {
        setValue('position', sessionData.position);
      }
    } else {
      // Initialize with today's date for 'today' selection
      const initialDate = getNextNearest30Min(new Date());
      setValue('dateTime', initialDate);
      setValue('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
      setValue('quickSelect', 'today');
      setQuickSelect('today');
    }
    return () => { };
  }, [sessionData]);

  // Initialize program from selectedProgram prop, sessionData, and programsData
  useEffect(() => {
    if (programsData?.getAllProgram) {
      // Handle edit mode - sessionData takes priority
      if (sessionData?.programId) {
        const program = programsData.getAllProgram.find(
          (p) => p?._id === sessionData.programId,
        );
        if (program) {
          const programName = program.programName?.toLowerCase() || '';
          setCurrentProgram(programName);
          setCurrentProgramId(program._id);
        }
        // Fallback: use programName from sessionData if program not found in programsData
        else if (sessionData.programName) {
          const programName = sessionData.programName.toLowerCase();
          setCurrentProgram(programName);
          setCurrentProgramId(sessionData.programId);
        }
      }
      // Handle initial program selection from props (for new sessions)
      else if (selectedProgram && !sessionData) {
        const program = programsData.getAllProgram.find(
          (p) => p?.programName?.toLowerCase() === selectedProgram.toLowerCase(),
        );
        if (program) {
          setCurrentProgram(selectedProgram);
          setCurrentProgramId(program._id);
        }
      }
    }
  }, [programsData, selectedProgram, sessionData]);

  const onSubmit = handleSubmit(async (data) => {
    const adjustedDateTime = dayjs(data.dateTime).tz(data.timezone, true).toISOString();

    // Build conditional data object
    const conditionalData: any = {};

    // Add trainingType only if it has a value
    if (data.trainingType) {
      conditionalData.trainingTypeId = data.trainingType;
    }

    // Add sport only if it has a value
    if (data.sport) {
      conditionalData.sportId = data.sport;
    }

    // Add position only if it has a value
    if (data.position) {
      conditionalData.position = data.position;
    }

    if (sessionData?._id) {
      updateSession({
        variables: {
          data: {
            _id: sessionData?._id,
            timeZone: data.timezone,
            traineeId: userDetails?._id || '',
            programId: currentProgramId,
            sessionStartTime: dayjs(adjustedDateTime).toISOString(),
            sessionEndTime: dayjs(adjustedDateTime).add(1, 'hour').toISOString(),
            roomId: '123',
            ...conditionalData,
          },
        },
      });
    } else {
      createSession({
        variables: {
          data: {
            timeZone: data.timezone,
            traineeId: userDetails?._id || '',
            traineeName: userDetails?.displayName || '',
            programId: currentProgramId,
            sessionStartTime: dayjs(adjustedDateTime).toISOString(),
            sessionEndTime: dayjs(adjustedDateTime).add(1, 'hour').toISOString(),
            ...conditionalData,
          },
        },
      });
    }
  });

  // const convertToToday = (dateTime: Date) => {
  //   const original = dayjs(dateTime);
  //   return dayjs()
  //     .startOf('day')
  //     .hour(original.hour())
  //     .minute(original.minute())
  //     .second(original.second())
  //     .toDate();
  // };

  // // Function to set dateTime to tomorrow with the original time
  // const convertToTomorrow = (dateTime: Date) => {
  //   const original = dayjs(dateTime);
  //   return dayjs()
  //     .add(1, 'day')
  //     .startOf('day')
  //     .hour(original.hour())
  //     .minute(original.minute())
  //     .second(original.second())
  //     .toDate();
  // };

  const selectedDateTime = watch('dateTime');
  const displayDate = quickSelect === 'custom' && !selectedDateTime ? undefined : selectedDateTime;

  const handleTimezoneChange = (value: string) => {
    setValue('timezone', value);
  };

  const Footer = () => {
    return (
      <div className='w-full flex items-center gap-4 pt-4 px-7 pb-7'>
        <Button
          id='schedule-session-cancel-btn'
          variant='secondary'
          className='w-full'
          onClick={() => handleClose()}
        >
          Cancel
        </Button>
        <Button
          id='schedule-session-save-btn'
          className='w-full'
          onClick={() => {
            const trainingType = getValues('trainingType');
            const sport = getValues('sport');
            const position = getValues('position');
            const quickSelect = getValues('quickSelect');
            const dateTime = getValues('dateTime');
            const timezone = getValues('timezone');

            // Set errors for missing required fields
            let hasErrors = false;

            // Always validate training type for FitPrime program
            if (currentProgram === 'fitprime' && !trainingType) {
              setError('trainingType', {
                type: 'manual',
                message: 'Training type is required.',
              });
              hasErrors = true;
            }

            // Always validate sport and position for FitVarsity program
            if (currentProgram === 'fitvarsity') {
              if (!sport) {
                setError('sport', {
                  type: 'manual',
                  message: 'Sport selection is required.',
                });
                hasErrors = true;
              }
              if (!position) {
                setError('position', {
                  type: 'manual',
                  message: 'Position is required.',
                });
                hasErrors = true;
              }
            }

            // Validate common required fields for all programs
            if (!quickSelect) {
              setError('quickSelect', {
                type: 'manual',
                message: 'Date selection is required.',
              });
              hasErrors = true;
            }

            if (!dateTime) {
              setError('dateTime', {
                type: 'manual',
                message: 'Date and time is required.',
              });
              hasErrors = true;
            }

            if (!timezone) {
              setError('timezone', {
                type: 'manual',
                message: 'Timezone is required.',
              });
              hasErrors = true;
            }

            // If no errors, proceed to confirmation
            if (!hasErrors) {
              setShowConfirmModal(true);
            }
          }} // Open confirm modal
        >
          Schedule
        </Button>
      </div>
    );
  };

  const handleConfirm = () => {
    // First, validate that the session is scheduled at least 12 hours in advance
    const selectedDateTime = getValues('dateTime');
    const now = dayjs();
    const minimumAdvanceTime = now.add(12, 'hours');

    if (dayjs(selectedDateTime).isBefore(minimumAdvanceTime)) {
      showToast({
        message: 'Sessions must be scheduled at least 12 hours in advance. Please plan accordingly!',
        variant: 'error'
      });
      setShowConfirmModal(false);
      return;
    }

    // If it's an existing session (sessionData exists), proceed with update
    if (sessionData?._id) {
      onSubmit();
    } else {
      // For new sessions, check if sessionBalance <= 0
      if (freeSessionBalance && freeSessionBalance > 0) {
        // Check if user needs profile completion (no ageRange means incomplete profile)
        if (!ageRange) {
          // Store session data in localStorage for profile completion
          const sessionFormData: any = {
            timeZone: getValues('timezone'),
            traineeId: userDetails?._id || '',
            traineeName: userDetails?.displayName || '',
            programId: currentProgramId,
            sessionStartTime: dayjs(getValues('dateTime'))
              .tz(getValues('timezone'), true)
              .toISOString(),
            sessionEndTime: dayjs(getValues('dateTime'))
              .tz(getValues('timezone'), true)
              .add(1, 'hour')
              .toISOString(),
          };

          // Add conditional fields only if they have values
          const trainingType = getValues('trainingType');
          const sport = getValues('sport');
          const position = getValues('position');

          if (trainingType) {
            sessionFormData.trainingTypeId = trainingType;
          }

          if (sport) {
            sessionFormData.sportId = sport;
          }

          if (position) {
            sessionFormData.position = position;
          }

          localStorage.setItem('pendingSessionData', JSON.stringify(sessionFormData));
          navigate(getRoutes.ProfileCompletion);
          handleClose();
        } else {
          // User has completed profile (ageRange exists), proceed with session creation
          onSubmit();
        }
      } else {
        // User has session balance, proceed with session creation
        onSubmit();
      }
    }
  };

  const selectedTrainingType = trainingTypes?.getAllTrainingType?.find(
    (type) => type?._id === watch('trainingType'),
  );

  const confirmModal = () => {
    const renderModalContent = () => {
      if (currentProgram === 'fitvarsity') {
        return (
          <div>
            <div className='flex flex-row gap-6 items-center mb-6'>
              <img src={CalenderIcon} height={79} width={79} />
              <div className='flex flex-col gap-3'>
                <h2 className='text-2xl text-white'>
                  <span className='font-bold'>{(freeSessionBalance ?? 0) > 0 ? 'Confirm Your Free Session' : 'Confirm Your Session'}</span>
                </h2>
                <p className='text-sm text-white'>
                  <span className='font-normal'>You&apos;re about to schedule your</span>{' '}
                  <span className='font-bold'>{(freeSessionBalance ?? 0) > 0 ? 'Free Session' : 'Session'}</span>{' '}
                  <span className='font-normal'>under the</span>{' '}
                  <span className='font-bold'>FitVarsity</span>{' '}
                  <span className='font-normal'>program.</span>
                </p>
              </div>
            </div>

            <div className='bg-gradient-to-br from-[#2F2F2F] to-[#2F2F2F] p-4 rounded-xl mb-5'>
              <div className='flex flex-col gap-4 mb-2'>
                <div className='flex flex-row gap-2 items-center'>
                  <img src={TriangleArrow} width={12} height={12} />
                  <span className='text-white text-base'>
                    Date: <strong>{dayjs(watch('dateTime')).format('MMM DD')}</strong>
                  </span>
                </div>
                <div className='flex flex-row gap-2 items-center'>
                  <img src={TriangleArrow} width={12} height={12} />
                  <span className='text-white text-base'>
                    Time: <strong>{dayjs(selectedDateTime).format('h:mm A')}</strong> to{' '}
                    <strong>{dayjs(selectedDateTime).add(1, 'hour').format('h:mm A')}</strong> (
                    {getTimezoneAbbreviation(watch('timezone'))})
                  </span>
                </div>
                <div className='flex flex-row gap-2 items-center'>
                  <img src={TriangleArrow} width={12} height={12} />
                  <span className='text-white text-base'>
                    Program: <strong>FitVarsity</strong>
                  </span>
                </div>
              </div>
            </div>
            {freeSessionBalance && freeSessionBalance > 0 && !ageRange ? (
              <p className='text-sm text-white mb-6'>
                Before we can assign the most suitable trainer for your session, we need a bit more
                information from you.
                <br />
                <br />
                Please complete your profile to proceed.
              </p>
            ) : ''}


          </div>
        );
      }

      if (currentProgram === 'fitcurve') {
        return (
          <div>
            <div className='flex flex-row gap-6 items-center mb-6'>
              <img src={CalenderIcon} height={79} width={79} />
              <div className='flex flex-col gap-3'>
                <h2 className='text-2xl text-white'>
                  <span className='font-bold'>{(freeSessionBalance ?? 0) > 0 ? 'Confirm Your Free Session' : 'Confirm Your Session'}</span>
                </h2>
                <p className='text-sm text-white'>
                  <span className='font-normal'>You&apos;re about to schedule your</span>{' '}
                  <span className='font-bold'>{(freeSessionBalance ?? 0) > 0 ? 'Free Session' : 'Session'}</span>{' '}
                  <span className='font-normal'>under the</span>{' '}
                  <span className='font-bold'>FitCurve</span>{' '}
                  <span className='font-normal'>program.</span>
                </p>
              </div>
            </div>

            <div className='bg-gradient-to-br from-[#2F2F2F] to-[#2F2F2F] p-4 rounded-xl mb-5'>
              <div className='flex flex-col gap-4 mb-2'>
                <div className='flex flex-row gap-2 items-center'>
                  <img src={TriangleArrow} width={12} height={12} />
                  <span className='text-white text-base'>
                    Date: <strong>{dayjs(watch('dateTime')).format('MMM DD')}</strong>
                  </span>
                </div>
                <div className='flex flex-row gap-2 items-center'>
                  <img src={TriangleArrow} width={12} height={12} />
                  <span className='text-white text-base'>
                    Time: <strong>{dayjs(selectedDateTime).format('h:mm A')}</strong> to{' '}
                    <strong>{dayjs(selectedDateTime).add(1, 'hour').format('h:mm A')}</strong> (
                    {getTimezoneAbbreviation(watch('timezone'))})
                  </span>
                </div>
                <div className='flex flex-row gap-2 items-center'>
                  <img src={TriangleArrow} width={12} height={12} />
                  <span className='text-white text-base'>
                    Program: <strong>FitCurve</strong>
                  </span>
                </div>
              </div>
            </div>

            {freeSessionBalance && freeSessionBalance > 0 && !ageRange ? (
              <p className='text-sm text-white mb-6'>
                Before we can assign the most suitable trainer for your session, we need a bit more
                information from you.
                <br />
                <br />
                Please complete your profile to proceed.
              </p>
            ) : ''}
          </div>
        );
      }

      if (currentProgram === 'fitprime') {
        return (
          <div>
            <div className='flex flex-row gap-6 items-center mb-6'>
              <img src={CalenderIcon} height={79} width={79} />
              <div className='flex flex-col gap-3'>
                <h2 className='text-2xl text-white'>
                  <span className='font-bold'>{(freeSessionBalance ?? 0) > 0 ? 'Confirm Your Free Session' : 'Confirm Your Session'}</span>
                </h2>
                <p className='text-sm text-white'>
                  <span className='font-normal'>You&apos;re about to schedule your</span>{' '}
                  <span className='font-bold'>{(freeSessionBalance ?? 0) > 0 ? 'Free Session' : 'Session'}</span>{' '}
                  <span className='font-normal'>under the</span>{' '}
                  <span className='font-bold'>FitPrime</span>{' '}
                  <span className='font-normal'>program.</span>
                </p>
              </div>
            </div>

            <div className='bg-gradient-to-br from-[#2F2F2F] to-[#2F2F2F] p-4 rounded-xl mb-5'>
              <div className='flex flex-col gap-4 mb-2'>
                <div className='flex flex-row gap-2 items-center'>
                  <img src={TriangleArrow} width={12} height={12} />
                  <span className='text-white text-base'>
                    Date: <strong>{dayjs(watch('dateTime')).format('MMM DD')}</strong>
                  </span>
                </div>
                <div className='flex flex-row gap-2 items-center'>
                  <img src={TriangleArrow} width={12} height={12} />
                  <span className='text-white text-base'>
                    Time: <strong>{dayjs(selectedDateTime).format('h:mm A')}</strong> to{' '}
                    <strong>{dayjs(selectedDateTime).add(1, 'hour').format('h:mm A')}</strong> (
                    {getTimezoneAbbreviation(watch('timezone'))})
                  </span>
                </div>
                <div className='flex flex-row gap-2 items-center'>
                  <img src={TriangleArrow} width={12} height={12} />
                  <span className='text-white text-base'>
                    Training Type: <strong>{selectedTrainingType?.title || 'Not Selected'}</strong>
                  </span>
                </div>
                <div className='flex flex-row gap-2 items-center'>
                  <img src={TriangleArrow} width={12} height={12} />
                  <span className='text-white text-base'>
                    Program: <strong>FitPrime</strong>
                  </span>
                </div>
              </div>
              {errors?.trainingType?.message && (
                <p
                  aria-label='error'
                  aria-errormessage={errors.trainingType?.message}
                  className='text-red text-xs mt-2'
                >
                  {errors?.trainingType?.message}
                </p>
              )}
            </div>

            {freeSessionBalance && freeSessionBalance > 0 && !ageRange ? (
              <p className='text-sm text-white mb-6'>
                Before we can assign the most suitable trainer for your session, we need a bit more
                information from you.
                <br />
                <br />
                Please complete your profile to proceed.
              </p>
            ) : ''}
          </div>
        );
      }

      // Default fallback
      return (
        <div>
          <div className='flex flex-row gap-2 items-center'>
            <img src={CalenderIcon} height={60} width={60} />
            <p className='font-bold text-xl text-white'>
              Are you sure you want to schedule this session?
            </p>
          </div>
          <div className='flex flex-col gap-2 bg-[#25282E] w-2/3 p-[10px] rounded-lg mt-3'>
            <span className='flex flex-row gap-2'>
              <img src={TriangleArrow} />
              Date: &nbsp; <strong>{dayjs(watch('dateTime')).format('MMM DD')}</strong>
            </span>
            <span className='flex flex-row gap-2'>
              <img src={TriangleArrow} />
              Time: &nbsp;<strong>{dayjs(selectedDateTime).format('h:mm A')}</strong> to
              <strong>{dayjs(selectedDateTime).add(1, 'hour').format('h:mm A')}</strong> (
              {getTimezoneAbbreviation(watch('timezone'))})
            </span>
            <span className='flex flex-row gap-2'>
              <img src={TriangleArrow} />
              Training Type: &nbsp;<strong>{selectedTrainingType?.title || 'Not Selected'}</strong>
            </span>
            {errors?.trainingType?.message && (
              <p
                aria-label='error'
                aria-errormessage={errors.trainingType?.message}
                className='text-red text-xs'
                style={{ marginTop: '0px !important' }}
              >
                {errors?.trainingType?.message}
              </p>
            )}
          </div>
          <span className='flex flex-row mt-2'>
            Click&nbsp;<strong>Confirm</strong>&nbsp;to proceed or&nbsp;<strong>Cancel</strong>
            &nbsp;to make changes.
          </span>
        </div>
      );
    };

    return (
      <Dialog open={showConfirmModal}>
        <DialogTitle>
          {currentProgram === 'fitvarsity'
            ? 'Confirm Scheduling'
            : currentProgram === 'fitcurve'
              ? 'Confirm FitCurve Session'
              : currentProgram === 'fitprime'
                ? 'Confirm FitPrime Session'
                : 'Confirm Scheduling'}
        </DialogTitle>
        <DialogContent
          onClose={() => setShowConfirmModal(false)}
          className='p-7 bg-[#00001C] rounded-lg flex flex-col gap-5'
        >
          {renderModalContent()}

          <div className='flex flex-row gap-3 justify-end'>
            <Button
              id='schedule-session-cancel-btn'
              variant='secondary'
              onClick={() => setShowConfirmModal(false)}
            >
              Cancel
            </Button>
            <Button
              id='schedule-session-confirm-btn'
              onClick={handleConfirm}
              loading={loading || updateLoading}
            >
              {freeSessionBalance && freeSessionBalance > 0 && !ageRange ? 'Complete Profile' : 'Confirm'}

            </Button>
          </div>
        </DialogContent>
      </Dialog>
    );
  };

  return (
    <form onSubmit={onSubmit}>
      <Modal
        title='Schedule New Session'
        open={open}
        onClose={handleClose}
        footer={<Footer />}
        className='bg-[#151525] md:max-w-[950px]'
      >
        <div className='space-y-6 px-7 overflow-auto max-h-[calc(100vh-210px)] pb-7 pt-4'>
          {/* Program Selection */}
          <div className='bg-[#00001C] p-[18px] rounded-[20px]'>
            <h4 className='mb-4 font-medium text-base leading-[1.4] text-white'>
              Select Program <span className='text-red-500'>*</span>
            </h4>
            <div className='flex gap-[10px]'>
              {programsLoading
                ? Array(3)
                  .fill(0)
                  .map((_, index) => <Skeleton key={index} className='h-[120px] flex-1' />)
                : programsData?.getAllProgram?.map((program) => {
                  const programName = program?.programName?.toLowerCase() || '';
                  const isSelected = currentProgram.toLowerCase() === programName;

                  // Map program names to icons
                  const getIcon = (name: string) => {
                    switch (name) {
                      case 'fitvarsity':
                        return FitVarsityIcon;
                      case 'fitcurve':
                        return FitCurveIcon;
                      case 'fitprime':
                        return FitPrimeIcon;
                      default:
                        return FitVarsityIcon; // fallback
                    }
                  };

                  return (
                    <div
                      key={program?._id}
                      className={`flex flex-col justify-center gap-3 cursor-pointer flex-1 px-[14px] py-[18px] rounded-xl ${isSelected
                        ? 'bg-[#181A32] border-2 border-[#0A7AFF]'
                        : 'bg-gradient-to-br from-[#2F2F2F] to-[#2F2F2F]'
                        }`}
                      onClick={() => handleProgramChange(programName, program?._id || '')}
                    >
                      <div className='flex items-center gap-3'>
                        <div className='w-8 h-8 flex items-center justify-center'>
                          <img
                            src={getIcon(programName)}
                            alt={program?.programName || ''}
                            className='w-8 h-8'
                          />
                        </div>
                        <span className='text-white text-xl font-medium leading-[1.22] tracking-[0.02em]'>
                          {program?.programName || ''}
                        </span>
                      </div>
                      <p className='text-[#C5C8D0] text-xs font-normal leading-[1.4]'>
                        {program?.description || ''}
                      </p>
                      {(freeSessionBalance === 0) && (
                        <p className='text-white text-xs font-medium leading-[1.4] mt-1'>
                          Balance: {
                            programName === 'fitprime' ? fitPrimeBalance :
                              programName === 'fitcurve' ? fitCurveBalance :
                                programName === 'fitvarsity' ? fitVarsityBalance :
                                  0
                          }
                        </p>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>

          {/* Sports Info for FitVarsity */}
          {currentProgram === 'fitvarsity' && (
            <div>
              <h4 className='mb-4 font-medium text-base leading-[1.4] text-white'>
                Sports Info <span className='text-red-500'>*</span>
              </h4>
              <div className='grid gap-4 sm:grid-cols-2'>
                <div className='space-y-2'>
                  {sportsLoading ? (
                    <Skeleton className='h-[56px] w-full' />
                  ) : (
                    <SelectComponent
                      id='select-sport'
                      label='Select Sport *'
                      values={sportsOptions}
                      value={watch('sport')}
                      setValue={(value) => {
                        setValue('sport', value, { shouldValidate: true });
                        // setSelectedSportId(value);
                      }}
                      className='border-[#515764] bg-transparent text-white'
                      error={errors.sport?.message}
                    />
                  )}
                </div>
                <div className='space-y-2'>
                  <CustomInput
                    id='position-input'
                    label='Position *'
                    value={watch('position')}
                    onChange={(e) => {
                      setValue('position', e.target.value, { shouldValidate: true });
                      // setSelectedPosition(e.target.value);
                    }}
                    placeholder='e.g., QB, RB, WR, TE, OL'
                    className='border-[#515764] bg-transparent text-white'
                    error={errors.position?.message}
                  // requiredItem={true}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Training Type Selection - Show for FitPrime or hide for others */}
          {currentProgram === 'fitprime' && (
            <div className='bg-[#00001C] p-4 rounded-xl'>
              <h4 className='mb-4 font-bold'>
                Select Training Type <span className='text-red-500'>*</span>
              </h4>
              <ToggleGroup
                type='single'
                value={watch('trainingType')}
                onValueChange={(val) => {
                  setValue('trainingType', val, { shouldValidate: true });
                }}
                className='grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3'
              >
                {trainingTypesLoading
                  ? Array(8)
                    .fill(0)
                    .map((_, index) => <Skeleton key={index} className='h-[76px] w-full' />)
                  : trainingTypes?.getAllTrainingType?.map((type) => (
                    <ToggleGroupItem
                      key={type?._id}
                      value={type?._id ?? ''}
                      className='flex gap-1 py-4 px-2 h-auto bg-[#25282E] border-[#25282E] hover:border-[#0A7AFF] hover:bg-[#181A32] hover:text-white data-[state=on]:bg-[#181A32] data-[state=on]:text-white data-[state=on]:border-[#0A7AFF] border-[3px] rounded-xl'
                    >
                      <img
                        src={type?.icon ?? ''}
                        alt={type?.title}
                        width={40}
                        height={40}
                        className='h-10 w-10'
                      />
                      <span className='text-sm font-medium whitespace-break-spaces'>
                        {type?.title}
                      </span>
                    </ToggleGroupItem>
                  ))}
              </ToggleGroup>
            </div>
          )}
          {errors?.trainingType?.message && (
            <p
              aria-label='error'
              aria-errormessage={errors.trainingType?.message}
              className='text-red text-xs'
              style={{ marginTop: '0px !important' }}
            >
              {errors?.trainingType?.message}
            </p>
          )}

          {/* Schedule Date and Time Section - Show for all programs */}
          <div className='space-y-5'>
            <h3 className='text-base font-semibold text-white'>
              Schedule your Date and Time <span className='text-red-500'>*</span>
            </h3>
            <div className='flex gap-2 max-w-[341px]'>
              <button
                type='button'
                className={`flex-1 flex items-center justify-center gap-3.5 px-5 py-2 h-9 rounded-xl text-xs font-medium ${quickSelect === 'today' ? 'bg-white text-black' : 'bg-[#343840] text-white'
                  }`}
                onClick={() => handleQuickSelect('today')}
              >
                Today
              </button>
              <button
                type='button'
                className={`flex-1 flex items-center justify-center gap-3.5 px-5 py-2 h-9 rounded-xl text-xs font-medium ${quickSelect === 'tomorrow' ? 'bg-white text-black' : 'bg-[#343840] text-white'
                  }`}
                onClick={() => handleQuickSelect('tomorrow')}
              >
                Tomorrow
              </button>
              <button
                type='button'
                className={`flex-1 flex items-center justify-center gap-1 px-5 py-2 h-9 rounded-xl text-xs font-semibold tracking-[0.02em] ${quickSelect === 'custom' ? 'bg-white text-black' : 'bg-[#343840] text-white'
                  }`}
                onClick={() => handleQuickSelect('custom')}
              >
                Custom
                <Calendar width={20} height={20} />
              </button>
            </div>
          </div>

          <div>
            <div className='grid gap-4 sm:grid-cols-3'>
              <div className='space-y-2 max-w-[350px]'>
                <DatePicker
                  key={datePickerKey}
                  placeholder='Date'
                  format='MMMM DD, YYYY'
                  dateDisabled={{ before: new Date() }}
                  selectedDate={displayDate}
                  disabled={quickSelect !== 'custom'}
                  onChange={(val) => {
                    if (val) {
                      const selectedDateTime = getValues('dateTime');
                      let updatedDateTime;

                      if (selectedDateTime) {
                        // If there's existing dateTime, preserve the time
                        const originalDateTime = dayjs(selectedDateTime);
                        updatedDateTime = dayjs(val)
                          .hour(originalDateTime.hour())
                          .minute(originalDateTime.minute())
                          .second(originalDateTime.second())
                          .millisecond(0)
                          .toDate();
                      } else {
                        // If no existing dateTime (custom mode), set to the selected date with default time
                        updatedDateTime = dayjs(val)
                          .hour(dayjs().hour())
                          .minute(dayjs().minute())
                          .second(0)
                          .millisecond(0)
                          .toDate();
                      }

                      setValue('dateTime', updatedDateTime, { shouldValidate: true });

                      const today = dayjs().startOf('day');
                      const tomorrow = today.add(1, 'day');
                      const selectedDate = dayjs(val).startOf('day');

                      if (selectedDate.isSame(today)) {
                        setValue('quickSelect', 'today');
                        setQuickSelect('today');
                      } else if (selectedDate.isSame(tomorrow)) {
                        setValue('quickSelect', 'tomorrow');
                        setQuickSelect('tomorrow');
                      } else {
                        setValue('quickSelect', 'custom');
                        setQuickSelect('custom');
                      }
                    }
                  }}
                  onClear={() => {
                    resetField('dateTime');
                  }}
                  clearIcon={false}
                />
              </div>
              <div className='space-y-2 max-w-[350px]'>
                <TimePicker
                  label='Start Time'
                  value={dayjs(selectedDateTime).format('hh:mm A')}
                  selectedDate={selectedDateTime && new Date(selectedDateTime)}
                  onTimeChange={(val) => {
                    setValue('dateTime', val, { shouldValidate: true });
                  }}
                />
              </div>
              <div className='space-y-2 max-w-[350px]'>
                {/* <Combobox
                  value={watch('timezone')}
                  onChange={(val) => setValue('timezone', val)}
                  options={timezonesList}
                  label='Timezone'
                /> */}
                <AvailabilityTimezone
                  options={timezonesList}
                  onChange={handleTimezoneChange}
                  value={watch('timezone')}
                />
              </div>
            </div>
            {errors?.dateTime?.message && (
              <p
                aria-label='error'
                aria-errormessage={errors.dateTime?.message}
                className='text-red text-xs mt-2'
                style={{ marginTop: '0px !important' }}
              >
                {errors?.dateTime?.message}
              </p>
            )}
          </div>

          <div className='flex items-center gap-2 bg-[linear-gradient(154.36deg,rgba(47,47,47,0.44)_11.3%,rgba(47,47,47,0.44)_95.38%)] p-4 rounded-lg'>
            <Calendar width={24} height={24} className='text-primary mr-1' />
            <p className='text-sm text-wrap text-gray-300'>
              Your Session will be scheduled on&nbsp;
              <span className='text-white'>{dayjs(watch('dateTime')).format('MMM DD')}</span>,
              from&nbsp;
              <span className='text-white'>{dayjs(selectedDateTime).format('h:mm A')}</span>&nbsp;
              to&nbsp;
              <span className='text-white'>
                {dayjs(selectedDateTime).add(1, 'hour').format('h:mm A')}{' '}
                {getTimezoneAbbreviation(watch('timezone'))}
              </span>
              .
            </p>
          </div>
        </div>
      </Modal>
      {confirmModal()}
    </form>
  );
};

export default ScheduleSession;

function getTimezoneAbbreviation(timezone: string) {
  const abbr = timezones?.filter((tz) => tz.utc.includes(timezone))[0]?.abbr;
  return abbr || timezone;
}
